package com.solevo.dist.application.models

import kotlinx.serialization.Serializable

data class Product(
    val productId: String = "",
    val localProductName: String? = null,
    val salesUnit: String? = null,
    val legalEntityId: String? = null,
    val descriptions: List<ProductDescription>? = null,
    val productType: String? = null,
    val productGroupId: String? = null,
    var details: ProductDetails? = ProductDetails(),
    var categories: List<Category>? = null,
    var categoryName: String? = null,
    var imageUrl: String? = null,
    val appItem: Boolean? = null,
    val maxOrderQuantity: Double? = null,
    val loyaltySchemes: List<LoyaltyScheme>? = null,
    val isReward: Boolean = false,
    val productImagesFileNames: List<String>? = null,
    val appUnit: String? = "",
    val appUnitConversionRate: Double? = null,
    val appConversionUnit: String? = "",
    val quantityInAppUnits: Double? = null,
    val allowedDeliveryLocation: List<AllowedDeliveryLocation>? = null
) {
    fun getProductName(): String {
        var name = productId
        if (!localProductName.isNullOrEmpty()) {
            name = localProductName
        } else if (!descriptions.isNullOrEmpty()) {
            var productDescription = descriptions.first()
            val localizedProductDescription =
                descriptions.firstOrNull { it.languageId == User.language }
            if (localizedProductDescription != null) {
                productDescription = localizedProductDescription
            }
            if (!productDescription.name.isNullOrEmpty()) {
                name = productDescription.name!!
            }
        }

        return name
    }

    fun category(): Category? {
        var category: Category? = null
        if (!categories.isNullOrEmpty()) {
            category = categories!!.filter { it.categoryLevel != null }.maxBy { it.categoryLevel!! }
        }
        return category
    }
}

@Serializable
data class Category(
    var categoryId: String? = null, var categoryLevel: Int? = null, var details: String? = null
)

@Serializable
data class ProductDetails(
    val productInformation: ProductInformation? = ProductInformation(),
    val ingredients: Ingredients? = Ingredients(),
    val preparation: Preparation? = Preparation(),
    val safety: Safety? = Safety(),
    val application: Application? = Application()
)

@Serializable
data class ProductDescription(
    val languageId: String = "",
    val description: String? = null,
    val name: String? = null,
    val id: String? = null,
)

@Serializable
data class ProductInformation(
    val conditioning: String? = null,
    val conditioningUnit: String? = null,
    val family: String? = null,
    val approvalNumber: String? = null,
    val details: String? = null,
    val generalScope: String? = null
)

@Serializable
data class Ingredients(
    val activeIngredients: String? = null,
    val formulation: String? = null,
    val chemicalFamily: String? = null
)

@Serializable
data class Preparation(
    val preparation: String? = null,
    val afterglow: String? = null,
    val preHarvestInterval: String? = null,
    val reEntryPeriod: String? = null
)

@Serializable
data class Safety(
    val toxicity: String? = null, val safetyPhrases: String? = null, val careAndInfo: String? = null
)

@Serializable
data class Application(
    val crops: String? = null,
    val approvalTarget: String? = null,
    val dose: String? = null,
    val period: String? = null,
    val details: String? = null,
    val highlights: String? = null
)

@Serializable
data class LoyaltyScheme(
    val loyaltyProgramId: String? = null,
    val loyaltySchemeType: String? = null,
    val loyaltyTierId: String? = null,
    val points: Double? = null
)

@Serializable
data class AllowedDeliveryLocation(
    val deliveryCostInPoints: Double? = null,
    val deliveryLocationMethodId: String? = null
)